module.exports = __webpack_public_path__ + "img/wutong_logo.69f5d0ae.png";